import * as React from "react";
import { useContext, useRef, useFocus, } from "react";
import { TouchableOpacity, TouchableHighlight, TouchableWithoutFeedback, Pressable, View, Linking, StyleSheet, Button, Text } from "react-native";
import { MonoText } from "./StyledText";
import SelectDropdown from "react-native-select-dropdown";
import SocialIconFacebook from "../screens/MiscImpl/SocialIconFacebook";
import SocialIconInstagram from "../screens/MiscImpl/SocialIconInstagram";
import SocialIconYoutube from "../screens/MiscImpl/SocialIconYoutube";
import SocialIconTwitter from "../screens/MiscImpl/SocialIconTwitter";
import { AppDataContext } from "../context/AppDataProvider.js";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider";
import { useWindowDimensions } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import * as SecureStore from "expo-secure-store";
import AsyncStorage from "@react-native-async-storage/async-storage";
import WebButton from "./WebButton";
import { Hoverable, } from 'react-native-web-hover'

export default function NavbarDesktop({ route, goBack, navigate, setParams }) {
  const { colors } = React.useContext(AppDataContext);
  const { width } = useWindowDimensions();
  const { categories, isLoggedIn, setLoggedIn } = useContext(AppDataContext);
  const { globalSettings } = useContext(GlobalSettingsContext);

  const [colourTheme1, setColourTheme1] = React.useState("#fff");
  const [dropdownOpenCategory, setDropdownOpenCategory] = React.useState(false);

  const mainRef = useRef();
  const [isEditing, setEditing] = React.useState(false);


  const [value, setValue] = React.useState();
  const input = React.useRef();

  React.useEffect(() => {
  }, [isLoggedIn]);


  if (width <= 500) {
    /**
     * Draw mobile navbar
     */
    return (
      <View
        style={{
          flexDirection: "row",
          flexWrap: 1,
          alignContent: "space-between",
          justifyContent: "space-between",
          justifySelf: "flex-start",
          margin: 15,
          backgroundColor: colors.background,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            navigate("ArticleList", {
              showCategoryName: "",
            });
          }}
        >
          <MonoText
            style={{ paddingRight: 32, paddingTop: 9, color: colors.text }}
          >
            Home
          </MonoText>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            navigate("MyModal");
          }}
        >
          <Ionicons name="md-menu" size={32} color={colors.vectorColor} />
        </TouchableOpacity>
      </View>
    );
  }


  const colorShade = (col, amt) => {
    col = col.replace(/^#/, '')
    if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2]

    let [r, g, b] = col.match(/.{2}/g);
    ([r, g, b] = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt])

    r = Math.max(Math.min(255, r), 0).toString(16)
    g = Math.max(Math.min(255, g), 0).toString(16)
    b = Math.max(Math.min(255, b), 0).toString(16)

    const rr = (r.length < 2 ? '0' : '') + r
    const gg = (g.length < 2 ? '0' : '') + g
    const bb = (b.length < 2 ? '0' : '') + b

    return `#${rr}${gg}${bb}`
  }

  return (
    <View
      style={{
        height: 48,
        minHeight: 48,
        backgroundColor: colors.background,
        borderBottomColor: 'silver',
        borderBottomWidth: 1,
      }}>

      <View
        style={{
          height: 48,
          minHeight: 48,
          justifyContent: "center",
          marginLeft: "auto",
          marginRight: "auto",
          width: 974,
          borderBottomColor: 'silver',
          borderBottomWidth: 1,
          backgroundColor: colors.background,
        }}
      >

        <View style={{
          flex: 1, flexDirection: "row",
        }}>
          <WebButton
            text="HOME"
            textColor={"black"}
            buttonOnPress={() => {
              navigate("ArticleList", {
                showCategoryName: "",
              });
            }}
            textStyle={styles.textStyleAction}
            style={{
              width: "auto",
              minWidth: 100,
              height: "48px",
              backgroundColor: colourTheme1,
              elevation: 1,
              zIndex: 1,
              borderBottomColor: 'silver',
              borderBottomWidth: 1,
            }}
            styleFade={
              {
                width: "auto",
                minWidth: 100,
                height: "48px",
                backgroundColor: colorShade(colourTheme1 + "", -40),
                elevation: 1,
                zIndex: 1,
                borderBottomColor: 'silver',
                borderBottomWidth: 1,
              }
            } />

          <Pressable >
            {({ hovered, focused, pressed }) => {
              return (
                <React.Fragment>
                  <View pointerEvents='none'>
                    <WebButton
                      text="CATEGORY"
                      textColor={"black"}
                      dropdownData={categories}
                      textStyle={styles.textStyleAction}
                      style={{
                        width: "auto",
                        minWidth: 100,
                        height: "48px",
                        backgroundColor: colourTheme1,
                        elevation: 1,
                        zIndex: 1,
                        borderBottomColor: 'silver',
                        borderBottomWidth: 1,
                      }}
                      styleFade={
                        {
                          width: "auto",
                          minWidth: 100,
                          height: "48px",
                          backgroundColor: colorShade(colourTheme1 + "", -40),
                          elevation: 1,
                          zIndex: 1,
                          borderBottomColor: 'silver',
                          borderBottomWidth: 1,
                        }
                      }
                    />
                  </View>
                  {hovered && (
                    <React.Fragment>
                      <View>
                        {categories?.map((a, b) => {
                          return (<React.Fragment>
                            <View
                              style={{
                                backgroundColor: colors.background,
                                zIndex: 1,
                                elevation: 1,
                              }}>
                              <TouchableOpacity
                                style={{
                                  width: "100%",
                                  minWidth: 100,
                                  height: "48px",
                                  backgroundColor: colourTheme1,
                                  elevation: 1,
                                  zIndex: 1,
                                  borderBottomColor: 'silver',
                                  borderBottomWidth: 1,
                                }}
                                onPress={() => {
                                  if (route && route.name && route.name === "ArticleList") {
                                    setParams({
                                      showCategoryName: a?.category_name + "",
                                    });
                                  } else {
                                    navigate("ArticleList", {
                                      showCategoryName: a?.category_name + "",
                                    });
                                  }
                                }}
                              >
                                <Text style={styles.textStyleAction}>
                                  {a.category_name.toUpperCase()}
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </React.Fragment>);
                        })}
                      </View>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )
            }}
          </Pressable>

          <WebButton
            text="SUBSCRIBE"
            textColor={"black"}
            textStyle={styles.textStyleAction}
            buttonOnPress={() => {
              navigate("SubscribeNewsletter", {
                showCategoryName: "",
              });
            }}
            style={{
              width: "auto",
              minWidth: 100,
              height: "48px",
              backgroundColor: colourTheme1,
              elevation: 1,
              zIndex: 1,
              borderBottomColor: 'silver',
              borderBottomWidth: 1,
            }}
            styleFade={
              {
                width: "auto",
                minWidth: 100,
                height: "48px",
                backgroundColor: colorShade(colourTheme1 + "", -40),
                elevation: 1,
                zIndex: 1,
                borderBottomColor: 'silver',
                borderBottomWidth: 1,
              }
            } />

          <Pressable>
            {({ hovered, focused, pressed }) => {
              return (
                <React.Fragment>
                  <View pointerEvents='none'>
                    <WebButton
                      text="ACCOUNT"
                      textColor={"black"}
                      dropdownData={isLoggedIn ? ["Change Password", "Sign out"] : ["Login", "Sign-up"]}
                      textStyle={styles.textStyleAction}
                      style={{
                        width: "auto",
                        minWidth: 100,
                        height: "48px",
                        backgroundColor: colourTheme1,
                        elevation: 1,
                        zIndex: 1,
                        borderBottomColor: 'silver',
                        borderBottomWidth: 1,
                      }}
                      styleFade={
                        {
                          width: "auto",
                          minWidth: 100,
                          height: "48px",
                          backgroundColor: colorShade(colourTheme1 + "", -40),
                          elevation: 1,
                          zIndex: 1,
                          borderBottomColor: 'silver',
                          borderBottomWidth: 1,
                        }
                      }
                    />
                  </View>
                  {hovered && (
                    <React.Fragment>
                      <View>
                        {isLoggedIn ? ["Change Password", "Sign out"] : ["Login", "Sign-up"]?.map((a, b) => {
                          return (<React.Fragment>
                            <View
                              style={{
                                backgroundColor: colors.background,
                                zIndex: 1,
                                elevation: 1,
                              }}>
                              <TouchableOpacity
                                style={{
                                  width: "100%",
                                  minWidth: 100,
                                  height: "48px",
                                  backgroundColor: colourTheme1,
                                  elevation: 1,
                                  zIndex: 1,
                                  borderBottomColor: 'silver',
                                  borderBottomWidth: 1,
                                }}
                                onPress={async () => {
                                  let selectedItem = a.toLowerCase();
                                  if (selectedItem === "login") {
                                    navigate("Login");
                                  } else if (selectedItem === "sign-up") {
                                    navigate("Register");
                                  } else if (selectedItem === "change password") {
                                    navigate("Change Password");
                                  } else if (selectedItem === "sign out") {
                                    try {
                                      var isMobile = await SecureStore.isAvailableAsync();
                                      if (!isMobile) {
                                        AsyncStorage.removeItem("authentication_data");
                                      } else {
                                        SecureStore.deleteItemAsync("authentication_data");
                                      }
                                    } catch (exception) {
                                      console.log(exception);
                                    }
                                    setLoggedIn(false);
                                  }
                                }}
                              >
                                <Text style={styles.textStyleAction}>
                                  {a.toUpperCase()}
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </React.Fragment>);
                        })}
                      </View>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )
            }}
          </Pressable>
          <Pressable>
            {({ hovered }) => {
              return (
                <React.Fragment>
                  <View pointerEvents='none'>
                    <WebButton
                      text="ABOUT"
                      textColor={"black"}
                      dropdownData={[
                        "Privacy Policy",
                        "About Us",
                        "Terms and Conditions",
                        "Cookie Policy",
                      ]}
                      textStyle={styles.textStyleAction}
                      style={{
                        width: 100,
                        maxWidth: 100,
                        height: "48px",
                        backgroundColor: colourTheme1,
                        elevation: 1,
                        zIndex: 1,
                        borderBottomColor: 'silver',
                        borderBottomWidth: 1,
                      }}
                      styleFade={
                        {
                          width: 100,
                          maxWidth: 100,
                          height: "48px",
                          backgroundColor: colorShade(colourTheme1 + "", -40),
                          elevation: 1,
                          zIndex: 1,
                          borderBottomColor: 'silver',
                          borderBottomWidth: 1,
                        }
                      }
                    />
                  </View>
                  {hovered && (
                    <React.Fragment>
                      <View>
                        {[
                          "Privacy Policy",
                          "About Us",
                          "Terms and Conditions",
                          "Cookie Policy",
                        ]?.map((a, b) => {
                          return (<React.Fragment>
                            <View
                              style={{
                                backgroundColor: colors.background,
                                zIndex: 1,
                                elevation: 1,
                              }}>
                              <TouchableOpacity
                                style={{
                                  width: 240,
                                  minWidth: 240,
                                  height: "48px",
                                  backgroundColor: colourTheme1,
                                  elevation: 1,
                                  zIndex: 1,
                                  borderBottomColor: 'silver',
                                  borderBottomWidth: 1,
                                }}
                                onPress={async () => {
                                  navigate("Information", { data: a });
                                }}
                              >
                                <Text style={styles.textStyleActionLeft}>
                                  {a.toUpperCase()}
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </React.Fragment>);
                        })}
                      </View>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )
            }}
          </Pressable>
          <View style={{ flex: 1, marginTop: 8, alignItems: "center", alignSelf: "center", flexDirection: "row-reverse", marginBottom: 12, alignContent: "flex-end", paddingRight: 8 }}>
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(
                  "https://" +
                  String(
                    globalSettings?.find(
                      (a) => a.description.toLowerCase() === "facebook link"
                    )?.value
                  )
                )
              }
            >
              <SocialIconFacebook />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(
                  "https://" +
                  String(
                    globalSettings?.find(
                      (a) => a.description.toLowerCase() === "instagram link"
                    )?.value
                  )
                )
              }
            >
              <SocialIconInstagram />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(
                  "https://" +
                  String(
                    globalSettings?.find(
                      (a) => a.description.toLowerCase() === "youtube link"
                    )?.value
                  )
                )
              }
            >
              <SocialIconYoutube />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(
                  "https://" +
                  String(
                    globalSettings?.find(
                      (a) => a.description.toLowerCase() === "twitter link"
                    )?.value
                  )
                )
              }
            >
              <SocialIconTwitter />
            </TouchableOpacity>
          </View>
        </View>
      </View >
    </View >
  );
}


const styles = StyleSheet.create({
  title: {
    fontWeight: "bold",
    fontSize: 30,
    padding: 24,
    textAlign: "center"
  },
  textStyleAction: {
    lineHeight: "48px",
    alignItems: "center",
    alignSelf: "center",
    position: "absolute",
    justifyContent: "center",
    textAlignVertical: 'center',
    flexDirection: 'row',
    fontSize: 15,
    fontWeight: "bold",
    textAlign: 'center',
    textAlignVertical: 'center',
    height: 48,
    elevation: 5,
    zIndex: 5,
    fontFamily: "oswald-regular",
    color: "black",
    maxWidth: 100,
  },
  textStyleActionLeft: {
    lineHeight: "48px",
    position: "absolute",
    flexDirection: 'row',
    fontSize: 15,
    fontWeight: "bold",
    paddingLeft: 32,
    height: 48,
    elevation: 5,
    zIndex: 5,
    fontFamily: "oswald-regular",
    color: "black",
  },
});